// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Alert = createStyle({
  alignItems: 'center',
  p: '$3',
  flexDirection: 'row',
  borderRadius: '$sm',
  variants: {
    action: {
      error: {
        bg: '$statusErrorSubtle',
        borderColor: '$statusError',
        _icon: {
          color: '$statusError',
        },
        _dark: {
          bg: '$statusErrorSubtle',
          borderColor: '$statusError',
          _icon: {
            color: '$statusError',
          },
        },
      },
      warning: {
        bg: '$statusWarningSubtle',
        borderColor: '$statusWarning',
        _icon: {
          color: '$statusWarning',
        },
        _dark: {
          bg: '$statusWarningSubtle',
          borderColor: '$statusWarning',
          _icon: {
            color: '$statusWarning',
          },
        },
      },
      success: {
        bg: '$statusSuccessSubtle',
        borderColor: '$statusSuccess',
        _icon: {
          color: '$statusSuccess',
        },
        _dark: {
          bg: '$statusSuccessSubtle',
          borderColor: '$statusSuccess',
          _icon: {
            color: '$statusSuccess',
          },
        },
      },
      info: {
        bg: '$statusInfoSubtle',
        borderColor: '$statusInfo',
        _icon: {
          color: '$statusInfo',
        },
        _dark: {
          bg: '$statusInfoSubtle',
          borderColor: '$statusInfo',
          _icon: {
            color: '$statusInfo',
          },
        },
      },
      muted: {
        bg: '$bgSubtle',
        borderColor: '$borderLight',
        _icon: {
          color: '$textSubtle',
        },
        _dark: {
          bg: '$bgSubtle',
          borderColor: '$borderLight',
          _icon: {
            color: '$textSubtle',
          },
        },
      },
    },

    variant: {
      solid: {},
      outline: {
        borderWidth: '$1',
        bg: '$bgCard',
        _dark: {
          bg: '$bgCard',
        },
      },
      accent: {
        borderLeftWidth: '$4',
      },
      'accent-flush': {
        borderLeftWidth: '$4',
        px: 0,
      },
      flush: {
        px: 0,
      },
    },
  },

  compoundVariants: [
    {
      action: 'error',
      variant: 'solid',
      value: {
        bg: '$statusError',
        _icon: {
          color: '$textOnError',
        },
        _text: {
          color: '$textOnError',
        },
      },
    },
    {
      action: 'warning',
      variant: 'solid',
      value: {
        bg: '$statusWarning',
        _icon: {
          color: '$textOnWarning',
        },
        _text: {
          color: '$textOnWarning',
        },
      },
    },
    {
      action: 'success',
      variant: 'solid',
      value: {
        bg: '$statusSuccess',
        _icon: {
          color: '$textOnSuccess',
        },
        _text: {
          color: '$textOnSuccess',
        },
      },
    },
    {
      action: 'info',
      variant: 'solid',
      value: {
        bg: '$statusInfo',
        _icon: {
          color: '$textOnInfo',
        },
        _text: {
          color: '$textOnInfo',
        },
      },
    },
    {
      action: 'muted',
      variant: 'solid',
      value: {
        bg: '$neutral600',
        _icon: {
          color: '$white',
        },
        _text: {
          color: '$white',
        },
      },
    },
  ],

  defaultProps: {
    variant: 'solid',
    action: 'info',
  },
});
